export default "__VITE_ASSET__XRQ3$Wnb__"